import type { ErrorMessageType } from "@freightsimple/ui-core/FormLayout/FormItem";
import { LocationType } from "@freightsimple/generated-dashboard-openapi-client/models/LocationType";
import { isEmptyOrUndefined } from "@/Helpers/isNotEmptyOrUndefined";

export function locationsErrorMessageForBoothNumber(
  boothNumber: string,
  locationType: LocationType,
): ErrorMessageType {
  if (locationType !== LocationType.TradeShow) {
    return undefined;
  }

  if (isEmptyOrUndefined(boothNumber)) {
    return `Required`;
  } else {
    return undefined;
  }
}
